import { render, staticRenderFns } from "./RatingProfessorGrid.vue?vue&type=template&id=217d436c"
import script from "./RatingProfessorGrid.vue?vue&type=script&lang=js"
export * from "./RatingProfessorGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports